import { ComponentType } from 'react';

const convertObjectToURLParams = (obj: Record<string, unknown>): string => {
  const params = Object.entries(obj)
    .filter(([, value]) => value !== undefined && value !== null)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);

  return params.length > 0 ? `?${params.join('&')}` : '';
};

export type SocialPlatformType =
  | 'Facebook'
  | 'Twitter'
  | 'LinkedIn'
  | 'Telegram'
  | 'WhatsApp'
  | 'Reddit'
  | 'Email';

export interface PlatformDetails {
  Icon?: ComponentType;
  title?: string;
  message?: string;
  url: string;
  via?: string;
}

export type PlatformConfiguration = Record<SocialPlatformType, PlatformDetails>;

const formatTextWithUrl = (message: string, link: string) => {
  const URL_PLACEHOLDER = '{{url}}';

  if (message.includes(URL_PLACEHOLDER)) {
    return message.replace(URL_PLACEHOLDER, link);
  }

  return message ? `${message} ${link}` : link;
};

export type SocialLinkGenerator = (props: PlatformDetails) => string;

export const socialLinkGenerators: Record<SocialPlatformType, SocialLinkGenerator> = {
  Email: ({ url = '', title = '', message = '' }) => {
    message = formatTextWithUrl(message, url);
    return `mailto:${convertObjectToURLParams({ subject: title, body: message })}`;
  },

  // NOTE: facebook doesn't support next params anymore
  // quote: title,
  Facebook: ({ url = '' }) => {
    return `https://www.facebook.com/sharer/sharer.php${convertObjectToURLParams({ u: url })}`;
  },

  WhatsApp: ({ url = '', message = '' }) => {
    message = formatTextWithUrl(message, url);
    return `https://api.whatsapp.com/send${convertObjectToURLParams({ text: message })}`;
  },

  LinkedIn: ({ url = '' }) => {
    return `https://www.linkedin.com/sharing/share-offsite${convertObjectToURLParams({ url })}`;
  },

  // NOTE: 1. without url param share url will not work
  // NOTE: 2. url can be used as title
  Telegram: ({ url = '', message = '' }) => {
    message = formatTextWithUrl(message, url);
    return `https://t.me/share/url${convertObjectToURLParams({ text: message, url })}`;
  },

  // NOTE: twitter adding url at the end of the text before `via` separating it with space
  Twitter: ({ url = '', message = '', via = 'MagicSquareio' }) => {
    message = formatTextWithUrl(message, url);
    return `https://twitter.com/share${convertObjectToURLParams({ text: message, via })}`;
  },

  Reddit: ({ url = '', message = '', title = '' }) => {
    message = formatTextWithUrl(message, url);
    return `https://www.reddit.com/submit${convertObjectToURLParams({
      url,
      text: message,
      title,
    })}`;
  },
};
